import { PayloadAction, createSlice } from "@reduxjs/toolkit";
// Types
import { IDeltaHedgeExeDetailedStateTableSearchParam } from "../../Interfaces/deltaHedgeExe";

interface IMarketmakingSlice {
  searchParam: IDeltaHedgeExeDetailedStateTableSearchParam;
}

const initialState: IMarketmakingSlice = {
  searchParam: { groupId: 5 } as IDeltaHedgeExeDetailedStateTableSearchParam,
};

const DeltaHedgeExePhase3Slice = createSlice({
  name: "exePhase3",
  initialState,
  reducers: {
    setSearchParam: (
      store,
      action: PayloadAction<IDeltaHedgeExeDetailedStateTableSearchParam>
    ) => {
      store.searchParam = { ...store.searchParam, ...action.payload };
    },
  },
});

export const { setSearchParam } = DeltaHedgeExePhase3Slice.actions;
export default DeltaHedgeExePhase3Slice.reducer;
